import {
  ChartLineUp,
  ClockUser,
  BoundingBox,
  ListStar,
  Clock,
  Speedometer,
  ListNumbers,
  CheckIcon
} from '@phosphor-icons/react';
import TestTypeSelector from './TestTypeSelector';

export const BottomNavigation = ({
  currentScreen,
  onScreenChange,
  selectedTestTypes,
  onTestTypeChange,
  loading = false,
  categories = [],
  subjects = [],
  apiResponse = null
}) => {
  const menuItems = [
    { id: 'performance', label: 'Performance', icon: ChartLineUp },
    { id: 'timeline', label: 'Timeline', icon: ClockUser },
    { id: 'qs-type-breakup', label: 'Qs Type Breakup', icon: BoundingBox },
    { id: 'quality-of-attempt', label: 'Quality of Attempts', icon: ListStar },
    { id: 'time-analysis', label: 'Time Analysis', icon: Clock },
    { id: 'difficulty-analysis', label: 'Difficulty Analysis', icon: Speedometer },
    { id: 'chapter-analysis', label: 'Chapter Analysis', icon: ListNumbers },
  ];

  const testTypeSelectorProps = {
    selectedTypes: selectedTestTypes,
    onSelect: onTestTypeChange,
    categories: categories.length > 0 ? categories : [],
    subjects: subjects,
    apiResponse: apiResponse || {
      data: {
        categories: categories.length > 0 ? categories : [],
        subjects: subjects
      }
    },
    isMobile: true
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[var(--q3-surface-default)]  z-50">
      <div className="flex items-center px-2 py-3 gap-2">
        {/* Fixed Test Type Selector */}
        <div className="flex-shrink-0 h-1 flex items-center">
          {loading ? (
            <div className="h-full w-[150px] bg-[var(--q3-neutral-light)] rounded-full animate-pulse" />
          ) : (
            <div className="h-full flex items-center">
              <TestTypeSelector {...testTypeSelectorProps} />
            </div>
          )}
        </div>

        {/* Divider line */}
     <div className="h-6 w-[2px] bg-[var(--q3-stroke-normal)] mx-2" />


        {/* Scrollable Navigation Tabs */}
        <div className="flex overflow-x-auto scrollbar-hide gap-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentScreen === item.id;

            return (
              <button
                key={item.id}
                onClick={() => onScreenChange(item.id)}
                className={`flex-shrink-0 h-8 px-3 flex items-center gap-2 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer
                  ${
                    isActive
                      ? 'bg-[var(--q3-neutral-default)] text-[var(--q3-surface-default)]'
                      : 'bg-[var(--q3-surface-dim)] text-[var(--q3-neutral-default)] border-[var(--q3-stroke-normal)]'
                  }
                `}
              >
                {item.label}
                {isActive && (
                  <CheckIcon
                    size={16}
                    weight="bold"
                    className="text-[var(--q3-surface-default)]"
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;
